import React from "react";

const icons = {
  book: <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />,
  award: <path strokeLinecap="round" strokeLinejoin="round" d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2v8l1 1m3 0a6.5 6.5 0 01-1.39-4.38t1.39-4.38m4.61 0a6.5 6.5 0 011.39 4.38t-1.39 4.38M15 9V5a2 2 2 0 00-2-2H5z" />,
  play: <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />,
  chevronDown: <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />,
  checkCircle: <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />,
  xCircle: <path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />,
  info: <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />,
  clock: <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />,
  trophy: <path strokeLinecap="round" strokeLinejoin="round" d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2v8l1 1m3 0a6.5 6.5 0 01-1.39-4.38t1.39-4.38m4.61 0a6.5 6.5 0 011.39 4.38t-1.39 4.38M15 9V5a2 2 2 0 00-2-2H5z" />
};

function Icon({ name, className = "" }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      {icons[name]}
    </svg>
  );
}

export default Icon;
